import { render, staticRenderFns } from "./BalanceHeader.vue?vue&type=template&id=9b38d856&scoped=true&"
import script from "./BalanceHeader.vue?vue&type=script&lang=js&"
export * from "./BalanceHeader.vue?vue&type=script&lang=js&"
import style0 from "./BalanceHeader.vue?vue&type=style&index=0&id=9b38d856&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b38d856",
  null
  
)

export default component.exports